import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../../components/Seo";
import { ServiceIcon } from "../../components/ServiceIcon";
import { CallCta } from "../../components/CallCta";
import { Testimonials } from "../../components/Testimonials";
import { SERVICES_FR } from "../../data/site-fr";

export default function ServicesIndexFr() {
  return (
    <div data-testid="services-index-fr-page">
      <Seo
        lang="fr-CA"
        title="Services de Sécurité | Gardiens, Patrouilles, Ronde Incendie"
        description="Découvrez les services de sécurité de 1st Nations Security : gardiens en uniforme, patrouille mobile, sécurité de chantier, événementielle, ronde incendie et plus."
        path="/francais/services-de-securite/"
        jsonLd={[breadcrumbJsonLd([{ name: "Accueil", path: "/francais" }, { name: "Services de sécurité", path: "/francais/services-de-securite" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Fil d'Ariane">
            <Link to="/francais" className="hover:text-[#FF9100]" data-testid="breadcrumb-fr-accueil">Accueil</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Services de sécurité</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Services de <span className="text-[#FF9100]">Gardiennage</span> Professionnels
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-6">
            1st Nations Security offre toute la gamme des services de sécurité professionnels au Québec et au Manitoba — gardiens de sécurité en uniforme, patrouille mobile de sécurité, sécurité de chantier de construction, sécurité événementielle, ronde de sécurité incendie, réponse d'alarme et plus encore.
          </p>
          <p className="text-gray-400 leading-relaxed max-w-3xl mb-12">
            En tant qu'entreprise de sécurité détenue par des Autochtones, nous concevons chaque programme selon votre site, vos risques et votre budget. Choisissez un service ci-dessous pour voir ce qui est inclus et les villes que nous desservons.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES_FR.map((s) => (
              <Link
                key={s.slug}
                to={`/francais/services-de-securite/${s.slug}`}
                data-testid={`services-fr-card-${s.slug}`}
                className="group bg-[#14161C] hover:bg-[#1C1F28] border border-white/8 hover:border-[#FF9100]/40 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] group-hover:scale-110 transition-transform duration-300">
                    <ServiceIcon name={s.icon} />
                  </div>
                  <span className="text-xs uppercase tracking-widest text-gray-500">{s.category}</span>
                </div>
                <h2 className="font-heading text-lg font-semibold text-white mb-2 group-hover:text-[#FF9100] transition-colors">{s.title}</h2>
                <p className="text-sm text-gray-400 leading-relaxed mb-4">{s.shortDesc}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-[#FF9100]">
                  Détails du service <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Testimonials fr />
      <CallCta heading="Vous ne savez pas quel service choisir?" sub="Appelez notre répartition 24/7 et nous vous recommanderons la bonne couverture pour votre site." testid="services-fr-cta" />
    </div>
  );
}
